export const dvrPageTestIDs = {
  dvrPage: 'dvr_page',
  header: 'dvr_page_header',
};
